// extracted by mini-css-extract-plugin
module.exports = {"eventWindow":"CalendarViewYear__eventWindow___1YZL9","tooltipDateTitle":"CalendarViewYear__tooltipDateTitle____43Rn"};